import { FC } from 'react';

import { useAuthPageWrapperContext } from '../AuthPageWrapperContext';

export const Row: FC = ({ children }) => {
  const { cnBem } = useAuthPageWrapperContext();

  return <div className={cnBem('__row')}>{children}</div>;
};
